import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    logobox: {
      display: 'flex',
      marginBottom: '8px',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      justifyContent: 'center',
      borderBottom: '1px solid #5980a1',
      cursor: 'pointer',
      /* textAlign: 'center', */
      /* display: 'block', */
      // position: 'fixed',
      // top: 0,
      // left: 0,
      zIndex: 9,
      /* backgroundColor: '#FFF', */
      /* height: 80, */
    },
    logo: {
      display: 'flex',
      width: 42,
      height: 'auto',
    },
  };
});

export default useStyles;
